import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { AUDIT_ENGINE_ROUTE_PATHS } from './config';

export const AUDIT_ENGINE_ROUTES: TApplicationRoute[] = [
  {
    id: 'audit-engine',
    path: AUDIT_ENGINE_ROUTE_PATHS.auditEngine,
    component: lazy(() => import('./pages/audit-engine-page')),
    layout: 'default',
    permissions: { scopes: ['audit-engine'] },
    menu: {
      title: 'pages.auditEngine.title',
    },
  },
];
